// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"107":"dc02755b","189":"ca9ea2ee","453":"935ca320","602":"468ad317","711":"fd299bd3"}[chunkId] + ".chunk.js";
};